import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, watchEffect, ref } from 'vue'
import type { Booking } from '@/models/your-bookings'


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleDirections',
  props: {
    booking: null
  },
  setup(__props: any) {

const props = __props as {
  booking: Booking;
};



const mapDiv = ref<HTMLDivElement>()

let directionsService: google.maps.DirectionsService
let directionsRenderer: google.maps.DirectionsRenderer
let map: google.maps.Map | null = null
const driverMarker = new google.maps.Marker()


const updateDriverMarker = () => {
  const booking = props.booking

  const markerBounds = new google.maps.LatLngBounds()
  let driverLatLng

  const driver = booking.driverVehicle?.driver
  if (driver?.positionLat && driver?.positionLng) {
    driverLatLng = { lat: driver.positionLat, lng: driver.positionLng }
    driverMarker.setPosition(driverLatLng)
    markerBounds.extend(driverLatLng)

    driverMarker.setMap(map)
  } else {
    driverMarker.setMap(null)
  }
}

const drawRoute = () => {
  const request = {
    origin: props.booking.pickup,
    destination: props.booking.destination,
    travelMode: google.maps.TravelMode.DRIVING,
    provideRouteAlternatives: true,
    unitSystem: google.maps.UnitSystem.IMPERIAL,
  }

  directionsService.route(request, (response, status) => {
    if (response) {
      if (status == 'OK') {
        directionsRenderer.setDirections(response)

        const route = response.routes[0]
        map?.panToBounds(route.bounds)
      }
    }
  })
}

const createMap = () => {
  if (!mapDiv.value) {
    return;
  }

  const center: google.maps.LatLngLiteral = { lat: 53.3289963, lng: -6.3782051 }
  map = new google.maps.Map(mapDiv.value, {
    center,
    zoom: 8,
    fullscreenControl: true,
  })

  directionsService = new google.maps.DirectionsService()
  directionsRenderer = new google.maps.DirectionsRenderer({
  })

  directionsRenderer.setMap(map)

  drawRoute()
  watchEffect(updateDriverMarker)
}


onMounted(createMap)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "booking-details-map",
    ref_key: "mapDiv",
    ref: mapDiv
  }, null, 512))
}
}

})